/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventModel } from './EventModel';
import {
    EventModelFromJSON,
    EventModelFromJSONTyped,
    EventModelToJSON,
} from './EventModel';
import type { PetFormFieldIsRequiredModel } from './PetFormFieldIsRequiredModel';
import {
    PetFormFieldIsRequiredModelFromJSON,
    PetFormFieldIsRequiredModelFromJSONTyped,
    PetFormFieldIsRequiredModelToJSON,
} from './PetFormFieldIsRequiredModel';
import type { PetFormFieldsValuesInnerModel } from './PetFormFieldsValuesInnerModel';
import {
    PetFormFieldsValuesInnerModelFromJSON,
    PetFormFieldsValuesInnerModelFromJSONTyped,
    PetFormFieldsValuesInnerModelToJSON,
} from './PetFormFieldsValuesInnerModel';

/**
 * 
 * @export
 * @interface PetFormFieldsModel
 */
export interface PetFormFieldsModel {
    /**
     * This is the internal name of the pet attribute
     * @type {string}
     * @memberof PetFormFieldsModel
     */
    name: string;
    /**
     * This is meant to control the order the form field is displayed on the client
     * @type {number}
     * @memberof PetFormFieldsModel
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof PetFormFieldsModel
     */
    type: PetFormFieldsModelTypeEnum;
    /**
     * This is the customer facing label that is displayed to the customer
     * @type {string}
     * @memberof PetFormFieldsModel
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof PetFormFieldsModel
     */
    note?: string;
    /**
     * 
     * @type {PetFormFieldIsRequiredModel}
     * @memberof PetFormFieldsModel
     */
    isRequired: PetFormFieldIsRequiredModel;
    /**
     * 
     * @type {boolean}
     * @memberof PetFormFieldsModel
     */
    isDerived: boolean;
    /**
     * 
     * @type {Array<PetFormFieldsValuesInnerModel>}
     * @memberof PetFormFieldsModel
     */
    values?: Array<PetFormFieldsValuesInnerModel>;
    /**
     * 
     * @type {EventModel}
     * @memberof PetFormFieldsModel
     */
    event?: EventModel;
}


/**
 * @export
 */
export const PetFormFieldsModelTypeEnum = {
    Text: 'text',
    Number: 'number',
    SelectOne: 'selectOne',
    SelectMulti: 'selectMulti'
} as const;
export type PetFormFieldsModelTypeEnum = typeof PetFormFieldsModelTypeEnum[keyof typeof PetFormFieldsModelTypeEnum];


/**
 * Check if a given object implements the PetFormFieldsModel interface.
 */
export function instanceOfPetFormFieldsModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "order" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "isRequired" in value;
    isInstance = isInstance && "isDerived" in value;

    return isInstance;
}

export function PetFormFieldsModelFromJSON(json: any): PetFormFieldsModel {
    return PetFormFieldsModelFromJSONTyped(json, false);
}

export function PetFormFieldsModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetFormFieldsModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'order': json['order'],
        'type': json['type'],
        'label': json['label'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'isRequired': PetFormFieldIsRequiredModelFromJSON(json['isRequired']),
        'isDerived': json['isDerived'],
        'values': !exists(json, 'values') ? undefined : ((json['values'] as Array<any>).map(PetFormFieldsValuesInnerModelFromJSON)),
        'event': !exists(json, 'event') ? undefined : EventModelFromJSON(json['event']),
    };
}

export function PetFormFieldsModelToJSON(value?: PetFormFieldsModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'order': value.order,
        'type': value.type,
        'label': value.label,
        'note': value.note,
        'isRequired': PetFormFieldIsRequiredModelToJSON(value.isRequired),
        'isDerived': value.isDerived,
        'values': value.values === undefined ? undefined : ((value.values as Array<any>).map(PetFormFieldsValuesInnerModelToJSON)),
        'event': EventModelToJSON(value.event),
    };
}

